document.addEventListener('DOMContentLoaded', register);

function register() {
  const campaignSelect = document.getElementById('campaignCategorySelect');

  loadSelectData({ target: campaignSelect });

  campaignSelect.addEventListener('change', loadSelectData);
}

function loadSelectData(event) {
  //console.log(event.target.selectedOptions[0].dataset.category);
  let categoryId = event.target.selectedOptions[0].dataset.category;

  const campaignSubcategorySelectRows = {
    1: document.getElementById('subcategoryRow1'),
    2: document.getElementById('subcategoryRow2'),
  };

  const campaignSubcategorySelects = {
    1: document.getElementById('campaignSubcategorySelect1'),
    2: document.getElementById('campaignSubcategorySelect2'),
  };

  function hideAllSelects() {
    for (const key in campaignSubcategorySelectRows) {
      campaignSubcategorySelectRows[key].classList.add('is-hidden');
    }
  }

  function resetAllSelectNames() {
    for (const key in campaignSubcategorySelects) {
      campaignSubcategorySelects[key].removeAttribute('name');
    }
  }

  hideAllSelects();
  resetAllSelectNames();

  campaignSubcategorySelectRows[categoryId].classList.remove('is-hidden');
  campaignSubcategorySelects[categoryId].setAttribute(
    'name',
    'campaign_registration[awardSubCategory]'
  );
}
